@if ((activityListDataSource.loading$ | async) !== true) {
  <ngx-zero-state class="zero-state-data-source-empty">
    <p zero-state-title>{{getTitle() | async}}</p>
    <p zero-state-subtext>{{getSubText() | async}}</p>
    <div zero-state-body class="zero-state-body">
      @if (!isLti() && hasInstructorRoleOrAbove && (isFiltering$ | async) !== true) {
        <button
          data-cy="zero-invite-btn"
          class="secondary-btn zero-invite-btn"
          (click)="openInvite.emit()">
          {{'common_invite' | translate}}
        </button>
      }
      <span
        [tabindex]="(canCreateActivity$$ | async) ? -1 : 0"
        [matTooltip]="getActivityCreationDisabledMessage$$ | async"
        [matTooltipDisabled]="canCreateActivity$$ | async"
        [attr.aria-disabled]="(canCreateActivity$$ | async) !== true"
        matTooltipPosition="above"
        [attr.role]="(canCreateActivity$$ | async) !== true ? 'button' : ''">
        @if (hasInstructorRoleOrAbove && (isFiltering$ | async) !== true) {
          <button
            class="btn primary-btn manage-btn eligible-btn"
            data-cy="create-activity"
            translate="folder_view-create_button"
            [disabled]="(canCreateActivity$$ | async) !== true"
            (click)="openAssignmentSourceModal.emit()"
            [attr.aria-hidden]="(canCreateActivity$$ | async) !== true">
          </button>
        }
      </span>
    </div>
    <div zero-state-graphic-bottom>
      @if (selectedService.getGroup().hasInstructorRole(true) && (isFiltering$ | async) !== true) {
        <img
          class="instructor-image"
          src="https://staticassets.goreact.com/Rocket.svg"
          [attr.alt]="'group-view_zero-state-data-source-empty-title-instructor-without-filter' | translate"
          >
      }
      @if (selectedService.getGroup().hasPresenterRole()) {
        <img
          class="presenter-image"
        [src]="activeBrandService.getImage('astronaut-astroid.svg')"
          [attr.alt]="'group-view_zero-state-data-source-empty-title-presenter' | translate"
          >
      }
    </div>
  </ngx-zero-state>
}
